export const PHONE = 0;
export const TABLET = 1;
export const DESKTOP = 2;
